
// Lists class extends React.Component
export const BloodGroupList = [{
    value: "1",
    label: "O+",
},
{
    value: "2",
    label: "O-",
},
{
    value: "3",
    label: "A-",

},
{
    value: "4",
    label: "A+",

},
{
    value: "5",
    label: "B-",

},
{
    value: "6",
    label: "B+",

},
{
    value: "7",
    label: "AB-",

},
{
    value: "8",
    label: "AB+",

}];

export const SalaryRangeList = [
    { value: '0', label: "less than 10k" },
    { value: '1', label: "10k-20k" },
    { value: '2', label: "20k-30k" },
    { value: '3', label: "30k-40k" },
    { value: '4', label: "40k-50k" },
    { value: '5', label: "more than 50k" },
    { value: '6', label: "As per industry standard" }];

export const JobTypeList = [
    { value: '1', label: "Part-time" },
    { value: '2', label: "Full-time" },
    { value: '3', label: "Remote" },
    { value: '4', label: "Internship" },
    { value: '5', label: "Contract" }];

export const SalaryTypeList = [
    { value: '1', label: "Hourly" },
    { value: '2', label: "Monthly" },
    { value: '3', label: "Anually" },
    { value: '4', label: "Commission" },
    { value: '5', label: "Contract" }];

